export let FormType;
(function (FormType) {
  FormType["HUBSPOT"] = "HUBSPOT";
  FormType["CAPTURED"] = "CAPTURED";
  FormType["BLOG_COMMENT"] = "BLOG_COMMENT";
  FormType["FLOW"] = "FLOW";
  FormType["SURVEY"] = "SURVEY";
  FormType["TICKET_FORM"] = "TICKET_FORM";
  FormType["VIDEO_FORM"] = "VIDEO_FORM";
  FormType["FACEBOOK_LEAD_AD"] = "FACEBOOK_LEAD_AD";
})(FormType || (FormType = {}));
export let FormStatus;
(function (FormStatus) {
  FormStatus["DRAFT"] = "DRAFT";
  FormStatus["PUBLISHED"] = "PUBLISHED";
})(FormStatus || (FormStatus = {}));